import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "../view/Home";
import SignIn from "../view/login/SignIn";
import SignUp from "../view/login/SignUp";
import RecoverPassword from "../view/login/RecoverPassword";
import Profile from "../view/profile/Profile";
import PrivateRoute from "./private/PrivateRoute";
import PublicRoute from "./public/PublicRoute";
import Inquiries from "../view/inquiries/Inquiries";
import Television from "../view/services/television/Television";
import Bills from "../view/payments/Bills";
import NotifyPayment from "../view/payments/NotifyPayment";
import Error404 from "../view/Error/Error404";
import Salir from "../view/Error/Salir";
import Internet from "../view/services/internet/Internet";
import ViewReports from "../view/reports/ViewReports";
import GenerateReports from "../view/reports/GenerateReports";
import DetailsInternet from "../view/services/internet/DetailsInternet";
import DetailsTelevision from "../view/services/television/DetailsTelevision";
import BillDetails from "../view/payments/BillDetails";
import Streamer from "../view/services/Streaming/Streaming";
import DetailsStreamer from "../view/services/Streaming/DetailsStreaming";
import Telefonia from "../view/services/Telefonia/Telefonia";
import DetailsTelefonia from "../view/services/Telefonia/DetailsTelefonia";
import SaludIntegral from "../view/services/SaludIntegral/SaludIntegral";
import DetailsSaludIntegral from "../view/services/SaludIntegral/DetailsSaludIntegral";
import ViewDetails from "../view/payments/ViewDetails";
import ViewBills from "../view/payments/ViewBills";
import Corporativo from "../view/services/corporativo/Corporativo";
import NewPassword from "../view/login/NewPassword";
import ConfirmaRegistro from "../view/login/SignUpConfirm";
import BanescoConfirmation from "../view/payments/Steps/viewConfimation/banescoConfirmation";
import BanescoConfirmationFailed from "../view/payments/Steps/viewConfimation/banescoConfirmationFailed";
import ExecPayment from "../view/payments/ExecPayment";
import DetailsDatos from "../view/services/Datos/DetailsDatos";
import Datos from "../view/services/Datos/Datos";
import RetencionesCorpo from "../view/payments/Corporativo/Retenciones";
import DomiciliacionDebito from "../view/payments/Domiciliacion/domiciliacionDebitoCta";
import DomiciliacionCredito from "../view/payments/Domiciliacion/domiciliacionCredito";
import DomiciliacionConfirmation from "../view/payments/Domiciliacion/domiciliacionConfirmation";
import TipoDomiciliacion from "../view/payments/Domiciliacion/TypeDomiciliacion";
import TipoDomiciliacionInstrumento from "../view/payments/Domiciliacion/TypeDomiciliacionInst";
import ModalSessionTimeout from './../components/Modals/ModalSessionTimeout';
import { RouteProvider } from '../Global/Context/routeContext';


function AppRoutes() {
  
  return (
    <>
      <BrowserRouter>
       
          
          <ModalSessionTimeout/>
          
          <Routes>
            
            <Route element={<PublicRoute />}>
              <Route path="/cuenta" element={<SignIn />} />
              <Route path="/cuenta/signUp" element={<SignUp />} />
              <Route path="/cuenta/new-password" element={<RecoverPassword />} />
              <Route path="/cuenta/new-password/TOKEN/DOCIDENTIDAD" element={<NewPassword />} />
              <Route path="/cuenta/signUp/confirmar" element={<ConfirmaRegistro />} />
            
          
            </Route>
            <Route element={<PrivateRoute />}>
              
              <Route path="/cuenta/dashboard" element={<Home />} />
              <Route path="/cuenta/perfil" element={<Profile />} />
              <Route path="/cuenta/consultas" element={<Inquiries />} />
              <Route path="/cuenta/servicio-corporativo" element={<Corporativo />} />
              <Route path="/cuenta/servicio-de-internet" element={<Internet />} />
              <Route
                path="/cuenta/servicio-de-internet/detalle-internet" 
                 
                element={<DetailsInternet />}
              />
              <Route path="/cuenta/servicio-de-streaming" element={<Streamer />} />
              <Route
                path="/cuenta/servicio-de-streaming/detalle-streaming"
                element={<DetailsStreamer />}
              />
              <Route path="/cuenta/servicio-de-television" element={<Television />} />
              <Route
                path="/cuenta/servicio-de-television/detalle-television"
                element={<DetailsTelevision />}
              />
              <Route path="/cuenta/servicio-de-telefonia" element={<Telefonia />} />
              <Route
                path="/cuenta/servicio-de-telefonia/detalle-telefonia"
                element={<DetailsTelefonia />}
              />
              <Route path="/cuenta/servicio-de-salud-integral" element={<SaludIntegral />} />
              <Route
                path="/cuenta/servicio-de-salud-integral/detalle-salud-integral"
                element={<DetailsSaludIntegral />}
              />              
              <Route path="/cuenta/servicio-de-datos" element={<Datos />} />
              <Route
                path="/cuenta/servicio-de-datos/detalle-datos"
                element={<DetailsDatos />}
              />
              <Route path="/cuenta/saldo/" element={<Bills />} />
              <Route path="/cuenta/ver-facturas" element={<ViewBills />} />
              <Route path="/cuenta/pagos" element={<BillDetails />} />
              <Route path="/cuenta/pagos/estado-de-cuenta" element={<ViewDetails />} />
              <Route path="/cuenta/realizar-pago" element={<Bills />} />
              <Route path="/cuenta/notificar-pago" element={<NotifyPayment />} />
              <Route path="/cuenta/ver-reportes" element={<ViewReports />} />
              <Route path="/cuenta/generar-reportes" element={<GenerateReports />} />
              <Route path="/cuenta/result/banescoTxFallida" element={<BanescoConfirmationFailed />} />
              <Route path="/cuenta/result/banesco" element={<BanescoConfirmation />} />
              <Route path="/cuenta/notificacion-retenciones" element={<RetencionesCorpo />} />
              <Route path="/cuenta/domiciliacion/domiciliacion-debito" element={<DomiciliacionDebito />} />
              <Route path="/cuenta/domiciliacion/domiciliacion-credito" element={<DomiciliacionCredito />} />
              <Route path="/cuenta/domiciliacion" element={<TipoDomiciliacion />} />
              <Route path="/cuenta/domiciliacion/tipo-instrumento" element={<TipoDomiciliacionInstrumento />} />
              <Route path="/cuenta/domiciliacion/confirmation" element={<DomiciliacionConfirmation />} />

            </Route>
            <Route path="*" element={<Error404 />} />
            <Route path="/cuenta/salir" element={<Salir />} />

          </Routes>
      </BrowserRouter>
    </>
  );
}

export default AppRoutes;
